import React from 'react'

export const TabFunctionality: React.FC = () => {
    return <>TabFunctionality</>
}
